import React, { useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import LeadContext from '../../../providers/Lead/Lead.context';
import { useTranslation } from 'react-i18next';
import ChatIcon from 'icons/Chat.icon';
import { WithdrawButton } from '../WithdrawButton';
import { Loader } from 'ncoded-component-library';
import SessionLink from '../SessionLink';

import './AfterConfirmationActions.styles.scss';

type AfterConfirmationActionsProps = {
  className?: string;
};

const AfterConfirmationActions: React.FC<AfterConfirmationActionsProps> = ({
  className,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const { leadId, sessionId, enquiry, dealRoom } = useContext(LeadContext);

  const { t } = useTranslation();

  const actionButton = useMemo(() => {
    if (!sessionId || !enquiry) return null;

    return (
      <SessionLink listingEnquiryId={enquiry?._id} sessionId={sessionId} />
    );
  }, [enquiry, sessionId]);

  const classes = classNames('after-confirmation-actions', className);

  return (
    <div className={classes}>
      {isLoading && <Loader />}

      <p className="title">
        <ChatIcon />
        {t('yourEnquiryStatus')}
      </p>

      <p>{t('afterConfirmationAction')}</p>

      <div className="actions">
        {actionButton}

        <WithdrawButton
          leadId={leadId}
          dealId={dealRoom?._id}
          dealName={dealRoom?.name}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </div>
    </div>
  );
};

export default AfterConfirmationActions;
